<div class="login-main-container">
  <div class="logo-container">
    <img class="logo-img"
         src="assets/general-media/logo-peekandgo-full-white.svg"
         alt="logo-peekandgo"/>
  </div>
  <div class="login-form">
    <pkg-form-generator
      [formInstance]="loginFormConfig"
      [formValues]="formValues"
      [showFabValidate]="false"
      (callBack)="formValues = $event"></pkg-form-generator>

    <p class="login-forgot-wrap">
      <a routerLink="/forgot-password" class="login-forgot-link">Mot de passe oublié ?</a>
    </p>

    <div class="form-container txt-center">
      <simple-button label="Connexion"
                     [loader]="loaderLogin"
                     [color]="'var(--text-color)'"
                     [background]="'#fff'"
                     [AddClass]="'login-button'"
                     (callBack)="login()">
      </simple-button>
    </div>
  </div>

  <div class="bottom-container">
    Administration plateforme
  </div>
</div>
<notification [topBar]="false"></notification>
